class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('[data-discount-form]');
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('[data-apply-discount]');
    this.tags = this.querySelector('[data-discount-tags]');
    this.error = this.querySelector('[data-discount-error]');
    this.errorText = this.error?.querySelector('.errors__text');
    this.loading = false;

    this.onSubmitHandler = this.onSubmit.bind(this);
    this.onTagClickHandler = this.onTagClick.bind(this);

    this.button?.addEventListener('click', this.onSubmitHandler);
    this.input?.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit(event);
      }
    });
    this.tags?.addEventListener('click', this.onTagClickHandler);

    if (isStorageSupported('session')) {
      this.setupDiscount();

      // Persist discount when value changes (original theme behavior)
      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });

      // Keep live updates while typing
      this.input?.addEventListener('input', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.loading) return;

    const code = this.input?.value.trim();
    if (!code) {
      this.showError(this.defaultError());
      return;
    }

    this.toggleLoading(true);
    this.applyDiscount(code)
      .then((cartState) => {
        if (!cartState?.cart_level_discount_applications?.length) {
          this.showError(this.defaultError());
        } else {
          this.clearError();
        }
      })
      .catch(() => {
        this.showError(this.defaultError());
      })
      .finally(() => {
        this.toggleLoading(false);
      });
  }

  onTagClick(event) {
    const button = event.target.closest('[data-remove-discount]');
    if (!button || this.loading) return;

    event.preventDefault();
    this.toggleLoading(true);
    this.clearError();

    this.clearDiscount()
      .then(() => {
        if (this.input) {
          this.input.value = '';
          if (isStorageSupported('session')) {
            window.sessionStorage.removeItem('discount');
          }
        }
      })
      .catch(() => {
        this.showError(this.defaultError());
      })
      .finally(() => {
        this.toggleLoading(false);
      });
  }

  applyDiscount(code) {
    const base = theme.routes.root_url || '/';
    const normalizedBase = base.endsWith('/') ? base : `${base}/`;
    const url = `${normalizedBase}discount/${encodeURIComponent(code)}?return_to=${encodeURIComponent(window.location.pathname)}`;

    return fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    }).then(() => this.refreshSectionsAndState());
  }

  clearDiscount() {
    const body = JSON.stringify({ discount: '' });

    return fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(() => this.refreshSectionsAndState());
  }

  refreshSectionsAndState() {
    const sections = this.getSectionsToRender();
    const sectionNames = sections.map((section) => section.section).filter(Boolean).join(',');

    const sectionsPromise = sectionNames
      ? fetch(`${theme.routes.cart_url}?sections=${sectionNames}`)
        .then((response) => response.json())
        .then((state) => {
          sections.forEach((section) => {
            const element = document.getElementById(section.id);
            if (element && state[section.section]) {
              const html = this.getSectionInnerHTML(state[section.section], section.selector);
              if (typeof html !== 'undefined') {
                element.innerHTML = html;
              }
            }
          });
          return state;
        })
      : Promise.resolve();

    const cartPromise = fetch(`${theme.routes.cart_url}.js`).then((response) => response.json());

    return Promise.all([sectionsPromise, cartPromise]).then(([, cartState]) => cartState);
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null && this.input) {
      this.input.value = discount;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems?.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents'
      });
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter?.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents'
      });
      if (mainCartFooter.querySelector('.free-shipping')) {
        sections.push({
          id: 'main-cart-footer',
          section: mainCartFooter.dataset.id,
          selector: '.free-shipping'
        });
      }
    }

    return sections;
  }

  toggleLoading(isLoading) {
    this.loading = isLoading;
    if (this.button) {
      this.button.classList.toggle('loading', isLoading);
      this.button.toggleAttribute('disabled', isLoading);
    }
  }

  showError(message) {
    if (!this.error) return;

    this.error.classList.remove('hidden');
    if (this.errorText) {
      this.errorText.textContent = message;
    }
  }

  clearError() {
    if (!this.error) return;

    this.error.classList.add('hidden');
    if (this.errorText) {
      this.errorText.textContent = '';
    }
  }

  defaultError() {
    return this.dataset.defaultError || theme.cartStrings.error;
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
